import Vue from 'vue';
import Vuex from 'vuex';

// Sometimes we need our VueJS Web App to persist some information in browser local storage. It could be local settings, account info, or some tokens. We definitely don’t want to lose them once the page is refreshed. That’s why we need to use vuex-persistedstate.
import createPersistedState from "vuex-persistedstate";

// Modules
import auth from "./store-modules/auth.store";
import slides from './store-modules/slides.store'
import categories from './store-modules/categories.store'
import produits from "./store-modules/produits.store";
import panier from "./store-modules/panier.store";
import horaires from "./store-modules/horaires.store";
import settings from "./store-modules/settings.store";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins:[
        createPersistedState()
            // tout compte fait on garde l'user dans le state, et on l'envoie dans les requêtes ou on a besoin de lui en back
            // 💥💥💥 du coup, on n'utilise pas auth()->user() dans les controllers

            // 💥 On décide de ne pas persister "auth" car il se peut qu'en back il soit déconnecté après un certain temps,
            // mais qu'en front l'user est encore dans le localStorage ... du coup si on fait une requete en back auth()->user() retournera false
            // paths: ['auth', 'slides', 'categories', 'produits', 'panier', 'horaires']

    ],
    modules:{
        auth, slides, categories, produits, panier, horaires, settings
    },
    state: {
        loading: true,
    },
    getters: {
        //
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        }
    },
    actions: {
        //
    },
});
